import { render, staticRenderFns } from "./ActivarCuenta.vue?vue&type=template&id=4c27f381&scoped=true"
import script from "./ActivarCuenta.vue?vue&type=script&lang=ts"
export * from "./ActivarCuenta.vue?vue&type=script&lang=ts"
import style0 from "./ActivarCuenta.vue?vue&type=style&index=0&id=4c27f381&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c27f381",
  null
  
)

export default component.exports